module.exports = __webpack_public_path__ + "static/media/Intro.ab5a5d37.png";